import Model from '@/lib/data/Model';
// import User from './User';

class RiskImprovementLog extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'form_ques_data_ri_id' },
        { name: 'ri_status' },
        { name: 'record_date_utc' },
        { name: 'user_id' },
        // {
        //     name: 'user',
        //     association: {
        //         type: 'one',
        //         model: User,
        //     },
        // },
        { name: 'ri_comment' },
        { name: 'completion_date_utc' },
        { name: 'record_state' },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            method: 'DELETE',
            url: '/visit/riskimprovement/log/delete',
            params: ['id'],
        },
        {
            name: 'create',
            method: 'POST',
            url: '/visit/riskimprovement/log/save',
        },
    ];
}

export default RiskImprovementLog;
